export default {
  success: {
    title: {
      rechargine: '¡Gracias por tu recarga!',
      package: '¡Gracias por tu compra!'
    },
    folio_confirm: 'Número de confirmación: ',
    email_confirm: 'Te llegará una confirmación a tu correo electrónico: ',
    transaction: {
      title: 'Detalle de la transacción:',
      number: {
        id: 'result-success-number',
        label: 'Número:',
        test_id: 'qa_resultSuccess_number'
      },
      vigency: {
        id: 'result-success-vigency',
        label: 'Vigencia:',
        test_id: 'qa_resultSuccess_vigency'
      },
      no_vigency: {
        id: 'result-success-vigency',
        label: 'Sin vigencia',
        test_id: 'qa_resultSuccess_vigency'
      },
      price: {
        id: 'result-success-price',
        label: 'Precio:',
        test_id: 'qa_resultSuccess_price'
      },
      pack: {
        id: 'result-success-pack',
        label: 'Paquete:',
        test_id: 'qa_resultSuccess_pack'
      }
    },
    recurrent: {
      expiration: 'Tu paquete se renovará cada {exp}'
    },
    method_paid: {
      title: 'Método de pago utilizado:',
      card: 'Tarjeta'
    },
    button_exit: {
      default: 'Salir',
      mcw: 'Regresar al inicio'
    },
    button_close: 'Salir',
    button_send: 'Enviar',
    send_invoice: {
      title: '¡Factura Enviada!',
      description:
        'Se ha enviado tu factura correctamente, favor de revisar tu bandeja de entrada de correo.',
      button: 'Finalizar'
    },
    microcredit_description: 'El precio del paquete será descontado de tu próxima recarga.'
  },
  failed: {
    title: {
      main: '¡Compra no exitosa!',
      in_process: 'Procesando compra',
      default_error: 'Estimado usuario',
      system_error: 'Estimado usuario'
    },
    subtitle: {
      mcw_error:
        'Ha ocurrido un error en tu transacción. Valida tu información e inténtalo de nuevo más tarde',
      loan_error: 'Tienes un préstamo pendiente. <br /> Te invitamos a hacer una recarga',
      in_process: 'Tu compra está en proceso <br /> Recibirás un SMS cuando se haya completado',
      system_error:
        'Ha ocurrido un error. <br /> Por favor inténtalo de nuevo mas tarde. <br /> Comunícate con nosotros vía Whatsapp al 50242147100 para ser asistido',
      invoice_error:
        'Has superado tu límite de crédito permitidos, puedes completar tu compra pagando con tarjeta. <br/> Comunícate con nosotros vía Whatsapp al 50242147100 para ser asistido',
      credits_error:
        'Tu saldo es insuficiente, puedes efectuar una recarga aquí con tu tarjeta de crédito o debito o en tu punto de venta más cercano.',
      default_error: 'Tu compra ha sido rechazada, inténtalo de nuevo más tarde.',
      blacklisted_error:
        'No es posible realizar el pago de este número debido a que tiene registros de las transacciones no reconocidas. Le invitamos a realizar el pago en efectivo cualquier tienda Claro o banco del sistema.',
      credit_card_error:
        'No es posible procesar su transacción, por favor revise los datos ingresados o contacte a su banco para mayor información.',
      bin_not_whitelisted:
        'Hemos detectado que su transacción no ha sido procesada debido a que la forma de pago utilizada no pertenece a un Banco Nacional. <br /> Para poder realizar compras en nuestro sitio favor de enviar los primeros 8 dígitos del frente de su tarjeta y el país a: <span class="text-blue-700"> contacto.cecla.saldo@htech.com </span>'
    },
    button_exit: {
      default: 'Salir',
      mcw: 'Regresar al inicio'
    },
    button_close: 'Cerrar',
    button_pay: 'Pagar con tarjeta'
  }
}
